import { computed, ref } from 'vue'

import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', () => {
  const displayLoginPopup = ref(false)
  const displayPasswordPopup = ref(false)
  const storeIsAuthenticated = ref(false)
  const underConstructionActive = ref(false)
  const loaderEnabled = ref(false)
  const displayChangeUsernamePopup = ref(false)
  const getUserData = ref(null)
  const getUserLevel = ref('')
  const getUserSubscriptions = ref([])
  const getRentedMedia = ref([])
  const getRentedMediaIDs = ref([])
  const getEnumLookup = ref(null)
  const getCustomerGroupLookup = ref(null)
  const getUserProfile = ref(null)
  const getUserFavoriteVideos = ref(null)
  const getVixyParams = ref(null)
  const getProductionWebsiteUrl = ref('XXX')
  const triggerFavoriteFetch = ref(false)
  const displayMobileMenu = ref(true)
  const landingsPage = ref(false)

  const getTrainingStageElements = ref([])
  const submitTrainingStageElementsToTraining = ref(false)

  const getCustomerGroupList = ref([])
  //const submitCustomerGroupListToTraining = ref(false)
  const getCurrentCustomerGroupIndex = ref(0)

  const getCurrentTrainingStageIndex = ref(0)

  const getContentTypes = ref({
    faq: 'd5b94ec9-f65e-4995-bc45-3f2536d3251e',
    blog: 'dd451fde-60d0-4613-957e-8dc91baeeea8'
  })

  //Set default Vixy params
  getVixyParams.value = {
    // partner: 123123, //616
    // uiconfid: 123123 //23460905

    partner: 635,
    uiconfid: 23459563
  }

  function toggleLoginPopup() {
    displayLoginPopup.value = !displayLoginPopup.value
  }
  function showLoginPopup() {
    displayLoginPopup.value = true
  }
  function hideLoginPopup() {
    displayLoginPopup.value = false
  }
  function togglePasswordPopup() {
    displayPasswordPopup.value = !displayPasswordPopup.value
  }
  function showPasswordPopup() {
    displayPasswordPopup.value = true
  }
  function hidePasswordPopup() {
    displayPasswordPopup.value = false
  }
  function storeSetAuthenticated() {
    storeIsAuthenticated.value = true
  }
  function storeRemoveAuthenticatedStatus() {
    storeIsAuthenticated.value = false
  }
  function removeUnderConstruction() {
    underConstructionActive.value = false
  }
  function enableLoader() {
    loaderEnabled.value = true
    localStorage.setItem('loader-enabled', 'true')
  }
  function disableLoader() {
    loaderEnabled.value = false
    localStorage.setItem('loader-enabled', 'false')
  }
  function toggleLoader() {
    loaderEnabled.value = !loaderEnabled.value
    localStorage.setItem('loader-enabled', loaderEnabled.value.toString())
  }
  function hideChangeUsernamePopup() {
    displayChangeUsernamePopup.value = false
  }
  function showChangeUsernamePopup(state) {
    displayChangeUsernamePopup.value = true
  }
  function setUserData(data) {
    getUserData.value = data
  }
  function deleteUserData() {
    getUserData.value = null
  }
  function saveUserSubscriptions(data) {
    getUserSubscriptions.value = data
  }
  function saveRentedMedia(data) {
    getRentedMedia.value = data
  }
  function saveRentedMediaIDs(data) {
    getRentedMediaIDs.value = data
  }
  function deleteUserSavedData() {
    getUserSubscriptions.value = []
    getRentedMedia.value = []
    getRentedMediaIDs.value = []
  }
  function saveEnumLookup(data) {
    getEnumLookup.value = data
  }
  function saveUserProfile(data) {
    getUserProfile.value = data
  }
  function saveUserFavoriteVideos(data) {
    getUserFavoriteVideos.value = data
  }
  function doTriggerFavoriteFetch(data) {
    triggerFavoriteFetch.value = data
  }

  function toggleMobileMenuDisplay() {
    displayMobileMenu.value = !displayMobileMenu.value
  }

  function mobileMenuDisplayTrue() {
    displayMobileMenu.value = true
  }

  function setTrainingStageElements(data) {
    getTrainingStageElements.value = data
  }

  function setCurrentTrainingStageIndex(data) {
    getCurrentTrainingStageIndex.value = data
  }

  function triggerSubmitTrainingStageElementsToTraining(data) {
    submitTrainingStageElementsToTraining.value = data
  }

  function saveCustomerGroupLookup(data) {
    getCustomerGroupLookup.value = data
  }

  function setLandingsPage(data) {
    landingsPage.value = data
  }

  return {
    displayLoginPopup,
    displayPasswordPopup,
    storeIsAuthenticated,
    underConstructionActive,
    loaderEnabled,
    displayChangeUsernamePopup,
    getUserData,
    getUserLevel,
    getUserSubscriptions,
    getRentedMedia,
    getRentedMediaIDs,
    getEnumLookup,
    getCustomerGroupLookup,
    getUserProfile,
    getUserFavoriteVideos,
    getContentTypes,
    getVixyParams,
    getProductionWebsiteUrl,
    triggerFavoriteFetch,
    displayMobileMenu,
    getTrainingStageElements,
    submitTrainingStageElementsToTraining,
    getCustomerGroupList,
    getCurrentCustomerGroupIndex,
    getCurrentTrainingStageIndex,
    landingsPage,
    toggleLoginPopup,
    showLoginPopup,
    hideLoginPopup,
    togglePasswordPopup,
    showPasswordPopup,
    hidePasswordPopup,
    storeSetAuthenticated,
    storeRemoveAuthenticatedStatus,
    removeUnderConstruction,
    enableLoader,
    disableLoader,
    toggleLoader,
    hideChangeUsernamePopup,
    showChangeUsernamePopup,
    setUserData,
    deleteUserData,
    saveUserSubscriptions,
    saveRentedMedia,
    saveRentedMediaIDs,
    deleteUserSavedData,
    saveEnumLookup,
    saveUserProfile,
    saveUserFavoriteVideos,
    doTriggerFavoriteFetch,
    toggleMobileMenuDisplay,
    mobileMenuDisplayTrue,
    setTrainingStageElements,
    triggerSubmitTrainingStageElementsToTraining,
    setCurrentTrainingStageIndex,
    saveCustomerGroupLookup,
    setLandingsPage
  }
})
